import type { ImageView } from '@vizit/api';

/**
 * Whether a hero has a score Spark can learn from: its own hero score, or its score under the custom benchmark its
 * collection selected, which Spark learns from in place of its own.
 */
export function isHeroScoredForSpark(
  imageData: Pick<ImageView, 'hero_score'> | null | undefined,
  customPairScore: number | null | undefined,
): boolean {
  return imageData?.hero_score != null || customPairScore != null;
}
